/* global axios */
import ApiClient from './ApiClient';
import { requestConfig, resourcePath } from './lais/httpHelpers';

const commandKey = payload => {
  const supplied = payload?.idempotency_key || payload?.idempotencyKey;
  if (supplied) return supplied;

  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `dashboard-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const commandConfig = payload => {
  const idempotencyKey = commandKey(payload);
  const config = requestConfig();
  config.headers['Idempotency-Key'] = idempotencyKey;
  return { config, idempotencyKey };
};

class PublicContractsAPI extends ApiClient {
  constructor() {
    super('public_contracts', { accountScoped: true });
  }

  securityStatus() {
    return axios.get(
      resourcePath(this.url, 'security_status'),
      requestConfig()
    );
  }

  createSecurityIncident(payload = {}) {
    const { config, idempotencyKey } = commandConfig(payload);
    return axios.post(
      resourcePath(this.url, 'security_incidents'),
      {
        ...payload,
        idempotency_key: idempotencyKey,
      },
      config
    );
  }
}

export default new PublicContractsAPI();
